<template>
  <div :style="`top:${50 * i}`" class="absolute right-10" v-for="(noti, i) in notificaciones.filter(item => !item.closed)">
    <!-- Toast -->
    <div
      v-if="noti.porcentaje < 100 && noti.porcentaje > 0"
      class=" transition duration-300  max-w-xs relative bg-white border border-gray-400 rounded-xl shadow-lg dark:bg-neutral-800 dark:border-neutral-700"
      role="alert">
      <div class="flex p-2">
        <div class="shrink-0">
          <!-- Icon -->
          <span
            class="m-1 inline-flex justify-center items-center size-8 rounded-full bg-gray-100 text-gray-800 dark:bg-neutral-700 dark:text-neutral-200">
            <svg-icon type="mdi" :class="claseIcono(noti.porcentaje)" :path="mdiCloudUpload" ></svg-icon>
          </span>
          <!-- End Icon -->

          <button type="button" @click="closeToast(noti)"
            class="absolute top-3 end-3 inline-flex shrink-0 justify-center items-center size-5 rounded-lg text-gray-800 opacity-50 hover:opacity-100 focus:outline-none focus:opacity-100 dark:text-white">
            <span class="sr-only">Close</span>
            <XMarkIcon class="shrink-0 size-4"> </XMarkIcon>
          </button>
        </div>

        <div class="grow ms-3 me-5">
          <h3 class="text-gray-800 font-medium text-sm dark:text-white">
            {{ noti.cantidad }} de {{ noti.total }}
          </h3>

          <!-- Progress -->
          <div class="mt-0 flex flex-col gap-x-3">
            <span class="block mb-1.5 text-xs text-gray-500 dark:text-neutral-400">
              {{ noti.porcentaje ? parseFloat(noti.porcentaje.toString()).toFixed(2) : 0 }}% · {{ noti.porcentaje == 100 ? 'Cargue terminado correctamente': noti.mensajeUpload }}</span>
            <div class="flex w-full h-1 bg-gray-200 rounded-full overflow-hidden dark:bg-neutral-700" role="progressbar"
              :aria-valuenow="noti.porcentaje" aria-valuemin="0" aria-valuemax="100">
              <div
                :class="[claseBarra(noti.porcentaje),'flex flex-col justify-center overflow-hidden text-xs text-white text-center whitespace-nowrap ']"
                :style="`width: ${noti.porcentaje}%`"></div>
            </div>
          </div>
          <!-- End Progress -->
        </div>
      </div>
    </div>
  </div>
  <!-- End Toast -->
</template>
<script setup lang="ts">
import type { notiCargue } from '@/modules/Core/usings/constantes';
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { mdiCloudUpload} from '@mdi/js'
import { watch, ref } from 'vue'

const props = defineProps<{ notificaciones: notiCargue[] }>()
const notificaciones = ref(props.notificaciones)
watch(props, async (nuevasPropiedades, antiguasPropiedades) => {
  notificaciones.value = nuevasPropiedades.notificaciones
})

const claseIcono = (porcentaje: number) =>{
  if ( porcentaje >= 80 ) return 'text-green-700'
  if ( porcentaje >= 50 ) return 'text-blue-700'
  if ( porcentaje >= 30 ) return 'text-yellow-500'
  return 'text-gray-700'
}

const claseBarra = (porcentaje: number) =>{
  if ( porcentaje >= 80 ) return 'bg-green-700'
  if ( porcentaje >= 50 ) return 'bg-blue-700'
  if ( porcentaje >= 30 ) return 'bg-yellow-500'
  return 'bg-gray-700'
}
const closeToast = (noti: notiCargue) => {
  noti.closed = true
}
</script>
